import * as React from "react";
const IconFactoryAlt6 = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M58 13.4h-6.3V4.1c0-.6-.4-1-1-1s-1 .4-1 1v9.3h-6.3c-2.2 0-4 1.8-4 4v9.9H6c-2.2 0-4 1.8-4 4V57c0 2.2 1.8 4 4 4h52c2.2 0 4-1.8 4-4V17.4c0-2.2-1.8-4-4-4M4 56.9V31.3c0-1.1.9-2 2-2h33.3V59h-9.6V43.4c0-2.2-1.8-4-4-4h-8.2c-2.2 0-4 1.8-4 4v15.5H6c-1.1 0-2-.9-2-2m11.6 2V43.4c0-1.1.9-2 2-2h8.2c1.1 0 2 .9 2 2v15.5zm44.4-2c0 1.1-.9 2-2 2H41.3V17.4c0-1.1.9-2 2-2H58c1.1 0 2 .9 2 2z" />
  </svg>
);
export default IconFactoryAlt6;
